
import Vue from 'vue'
import { VTextarea } from 'vuetify/lib'
import JcdcProgressLinear from '@/components/jcdc/JcdcProgressLinear.vue'

export default Vue.extend({
  name: 'JcdcTextarea',
  components: {
    JcdcProgressLinear,
    VTextarea,
  },
  props: {
    color: { type: String, default: 'primary' },
    label: { type: String, required: true },
    dense: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    counter: { type: [Number, Boolean], default: 255 },
    minimum: { type: Number, default: undefined },
    rules: {
      type: Array as () => Array<(v: string) => void>,
      default: (): [] => [],
    },
    defaultValue: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    errorMessage: { type: String, default: undefined },
    rows: { type: Number, default: null },
  },
  data() {
    return {
      textValue: this.defaultValue,
      colorValue: this.color,
    }
  },
  computed: {
    computedRules(): Array<(v: string) => void> {
      const ruleArray: Array<(v: string) => void> = [...this.rules]
      // Required
      if (this.required) {
        ruleArray.push(
          (v: string) =>
            Boolean(v ? v.trim() : v) ||
            (this.errorMessage
              ? this.errorMessage
              : `${this.label} is required.`)
        )
      }
      // Min and max length on text input
      if (this.minimum) {
        ruleArray.push(
          (v: string) =>
            (v ? v.trim() : v || '').length >= this.minimum ||
            `Min ${this.minimum} characters`
        )
      }
      if (this.counter) {
        ruleArray.push(
          (v: string) =>
            (v ? v.trim() : v || '').length <= this.counter ||
            `Max ${this.counter} characters`
        )
      }
      return ruleArray
    },
    rowsCalc(): number {
      if (this.rows) return this.rows
      else if (this.dense) return 3
      return 5
    },
  },
  watch: {
    defaultValue() {
      this.textValue = this.defaultValue.trim()
    },
  },
  methods: {
    onFocus() {
      this.readonlyHandler()
    },
    onBlur() {
      if (this.readonly) {
        this.colorValue = this.color
      }
    },
    readonlyHandler() {
      this.readonly
        ? (this.colorValue = 'error')
        : (this.colorValue = this.color)
    },
  },
})
